import SearchParamsBase from "../../../../Elements/SearchParamsBase"
import InputTypesEnum from "../../../../Enums/InputTypesEnum";

export default class EvaluatorPaymentsSearchParams extends SearchParamsBase {
    initialize() {
        this.AsSassieAsgnId = "";
        this.IeExportPaymentId = "";
        this.IeStatusCode = "";
        this.IePaymentType = "";
        this.Method = "";
    }

    static fieldsInSearchBox = [
        { fieldName: "AsSassieAsgnId", label: "Apollo ID", className: "col-6", type: InputTypesEnum.Text },
        { fieldName: "IeXpid", label: "Export", className: "col-6", type: InputTypesEnum.Text },
        { fieldName: "IeTypeCode", label: "Type", className: "col-6", type: InputTypesEnum.EvaluatorPaymentTypeLookupItemSelect },
        { fieldName: "IeStatusCode", label: "Status", className: "col-6", type: InputTypesEnum.EvaluatorPaymentStatusLookupItemSelect, showCondition: (searchItem) => searchItem.Type !== "pending_approval" },
        { fieldName: "IePaymentType", label: "Method", className: "col-6", type: InputTypesEnum.EvaluatorPaymentMethodLookupItemSelect },
    ];

    static iconName = "fa-solid fa-search";
    static saveType = "EvaluatorPaymentsSearchParams";
}
